/**
 * Platform module registry (P4). The sidebar renders program groups from this
 * registry; the launcher renders one tile per granted module.
 * (docs/reference/app-plus/IMPLEMENTATION_PLAN.md, P4)
 */
import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard, SlidersHorizontal, AlertTriangle, BarChart3, Send,
} from 'lucide-react';

export interface ModuleNavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** exact NavLink matching (the MIPS Overview needs `end`) */
  end?: boolean;
}

export interface PlatformModule {
  code: 'mips' | 'app-plus';
  displayName: string;
  /** Sidebar group label */
  navLabel: string;
  navItems: ModuleNavItem[];
  /** Launcher tile route */
  homeRoute: string;
  /** Years the module supports; tile hidden + in-module empty state outside them. */
  supportedYears: (year: number) => boolean;
}

export const PLATFORM_MODULES: PlatformModule[] = [
  {
    code: 'mips',
    displayName: 'MIPS Registry',
    navLabel: 'MIPS',
    homeRoute: '/dashboard',
    supportedYears: () => true,
    navItems: [
      { label: 'Overview', to: '/dashboard', icon: LayoutDashboard, end: true },
      { label: 'Configuration', to: '/measure-selection', icon: SlidersHorizontal },
      { label: 'Gap Management', to: '/programs/mips/gap-management/quality', icon: AlertTriangle },
      { label: 'Insights', to: '/scorecards', icon: BarChart3 },
      { label: 'Submit to CMS', to: '/submit', icon: Send },
    ],
  },
  {
    code: 'app-plus',
    displayName: 'APP Plus (MSSP)',
    navLabel: 'APP PLUS (MSSP)',
    homeRoute: '/programs/app-plus',
    supportedYears: (year) => year >= 2026,
    navItems: [
      // Overview restored 2026-07-14 (owner decision); rest per the locked mockup order.
      { label: 'Overview',       to: '/programs/app-plus',               icon: LayoutDashboard, end: true },
      { label: 'Configuration',  to: '/programs/app-plus/configuration', icon: SlidersHorizontal },
      { label: 'QPS Management', to: '/programs/app-plus/qps',           icon: AlertTriangle },
      { label: 'Insights',       to: '/programs/app-plus/insights',      icon: BarChart3 },
      { label: 'Submission',     to: '/programs/app-plus/submission',    icon: Send },
    ],
  },
];
